import { useLocalStorage as useLocalStorageHook } from "usehooks-ts";

const prefix = "studyos";

export function useLocalStorage<T>(key: string, initialValue: T) {
	return useLocalStorageHook(`${prefix}:${key}`, initialValue, {
		initializeWithValue: false,
	});
}
